<template>
  <div class="table-responsive" ref="scroll" style="height: 100%;position:relative">
    <table class="table" ref="table">
      <thead>
      <tr>
        <th v-for="(field, index) in fields" :key="index" style="background-color: white; ">
          {{ field.label }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(element, index) in drawableElements" :key="index" @click="selectFn($event, index)"
          @dblclick="onDoubleClick" :class="{'selectColor': selectColor!==undefined && selectIndex==index}">
        <td>{{ element.start }}</td>
        <td>{{ element.end }}</td>
        <td>{{ element.time }}</td>
        <td>{{ element.distance }}</td>
        <td>{{ element.amount }}</td>
        <td>{{ convertPayTypeToTxt(element.type) }}</td>
        <td>{{ element.employee }}</td>
      </tr>
      <!-- <tr>
        <td v-if="elements.length > 0" :colspan=elements.length class="remaining-box" >
          <button class="btn btn-sm btn-outline-light text-black" @click="selectAutoScrollN">Next Page</button>
        </td>
      </tr> -->
      </tbody>
    </table>
    <paginate
        v-show="pageInfo.totalElements"
        class="justify-content-lg-center mt-3"
        :page-count="pageInfo.totalPages"
        :force-page="pageInfo.currentPage"
        :first-last-button="true"
        first-button-text="<<"
        last-button-text=">>"
        prev-text="<"
        next-text=">"
        :hide-prev-next="true"
        :click-handler="pageHandler">
    </paginate>
  </div>
</template>

<script setup>
import {computed, ref, onMounted} from 'vue';
import PayType, {convertPayTypeToTxt} from "@/type/PayType";
import Paginate from "vuejs-paginate-next";

const props = defineProps({
  fields: Object,
  allData: Object,
  elements: Object,
  onSelected: Function,
  onDoubleClick: Function,
  sales: Boolean || undefined,
  pageInfo: Object,
  selectColor: String
})

const selectIndex = ref(-1);

const scroll = ref("");
const emit = defineEmits(["scroll"]);
let pageIndex = 0;

const drawableElements = computed(() => {
  return props.elements;
});

const pageHandler = (pageNum) => {
  emit('scroll', pageNum);
}

const initPageIndex = () => {
  pageIndex = 0;
}

const selectFn = (event, index) => {
  selectIndex.value = index;
  props.onSelected(index);
}

onMounted(async() => {
  if( props.selectColor !== undefined ) {
    document.documentElement.style.setProperty('--select-tr-color', props.selectColor);
  }
});

defineExpose({
  initPageIndex
});

</script>

<style>
td {
  white-space: nowrap;
}

.table th {
  position: sticky;
  top: 0;
}
</style>

<style scoped>
.table {
  margin-bottom: 0;
}
:root{
  --select-tr-color: white;
}
.selectColor>td {
  background-color: var(--select-tr-color);
}
</style>
